/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Upload_Error_ForbiddenInputs */

const vi_file_upload_error_forbidden = /** @type {(inputs: File_Upload_Error_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tài khoản của bạn chưa có quyền tải tệp lên. Liên hệ quản trị viên để được cấp quyền.`)
};

/**

* @param {File_Upload_Error_ForbiddenInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const file_upload_error_forbidden = /** @type {((inputs?: File_Upload_Error_ForbiddenInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Upload_Error_ForbiddenInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_file_upload_error_forbidden(inputs)
});